import { getDealFilterCriteria } from '../declarations/filter/filter';
import { DealsSourceParams } from '../typings/deals';
import { FilterPartialExpression } from '../typings/filter';
import { SortDirection, SortParams } from '../typings/grid';

import { castStringToEnum } from './CastHelpers';
import { parseFilterFromString } from './FilterHelpers/FilterHelpers';

export interface NormalizeDealsSourceParamsData {
    sortKey?: string;
    sortDirection?: string;
    login: string;
    filter?: string;
    noStats?: string;
}

export class DealsSourceHelper {
    static normalizeSourceParams({
        sortKey,
        sortDirection,
        login,
        filter,
        noStats
    }: NormalizeDealsSourceParamsData): DealsSourceParams {
        return {
            login,
            sortParams: this.normalizeSortParams(sortKey, sortDirection),
            filter: filter ? this.normalizeFilter(filter) : undefined,
            noStats: noStats || undefined
        };
    }

    private static normalizeFilter(
        filterString: string
    ): FilterPartialExpression[] {
        const criteria = getDealFilterCriteria();

        return parseFilterFromString(criteria, filterString, true);
    }

    private static normalizeSortParams(
        sortKey?: string,
        sortDirection?: string
    ): SortParams {
        let sortParams: SortParams;

        const defaults = {
            key: 'name',
            direction: SortDirection.asc
        };

        if (sortKey) {
            sortParams = {
                key: sortKey,
                direction: sortDirection
                    ? castStringToEnum(sortDirection, SortDirection)
                    : SortDirection.desc
            };
        } else {
            sortParams = defaults;
        }

        return sortParams;
    }
}
